<template>
    <div>
    <label class="text-uppercase font-weight-500">Returns in</label>
    <label class="is-flex is-flex mt-1 is-align-items-center">
        <span class="mr-1">GBP</span>
        <b-field v-tooltip="'See Fund Returns in GBP or its Native currency'">
            <b-switch
                true-value="native"
                false-value="gbp"
                v-model="currencyNative"
                @input="submit"
                :disabled="isDisabled"
            >
            </b-switch>
        </b-field>
        Native
    </label>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: 'CurrencyToggle',
    props: {
        isDisabled: Boolean
    },
    data() {
        return {
            currencyNative: this.$store.state.search.currency
        }
    },
    watch: {
        '$store.state.search.currency': function (data) {
            this.currencyNative = data;
        }
    },
    methods:{
        submit(){
            axios.get('/search/saveccytoggledata',
                {
                    params: {
                        source: this.$store.state.compare.typeCompareDetail,
                        toggle: this.currencyNative
                    }
                }
            )
            this.$store.commit("search/SET_CURRENCY",this.currencyNative)
            this.$emit('currency-change')
        }
    },
    mounted() {
        this.currencyNative = this.$store.state.search.currency
    }
}
</script>
